import React, {FC, useId} from 'react';
import styles from './Checkbox2.module.css';

export type UiType = 'minimal' | 'standard';

interface Props {
  contentText?: string | React.ReactElement;
  onCheck: () => void;
  checked: boolean;
  uiType?: UiType;
  className?: string;
}

const Checkbox: FC<Props> = ({
  contentText,
  onCheck,
  checked,
  uiType = 'standard',
  className,
}: Props) => {
  const id = useId();
  const getRootClass = () => {
    switch (uiType) {
      case 'minimal':
        return styles.minimal;
      case 'standard':
      default:
        return styles.standart;
    }
  };

  return (
    <div
      className={`${getRootClass()} ${styles.container} ${
        className ? className : ''
      }`}
      onClick={onCheck}>
      <input id={id} type="checkbox" checked={checked} onChange={onCheck} />
      {contentText && (
        <label htmlFor={id} className={styles.textContent}>
          {contentText}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
